exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".posts .column-header {\n  border-top: 2px solid #e3f0f4;\n  padding: 0.5rem 1rem;\n  color: #7091c5; }\n\n.posts .post {\n  padding: 0.75rem 1rem;\n  border-top: 2px solid #e3f0f4; }\n  .posts .post .item-actions {\n    opacity: 0;\n    transition: all 200ms ease-in; }\n  .posts .post:hover {\n    cursor: pointer; }\n    .posts .post:hover .item-actions {\n      opacity: 1; }\n  .posts .post:hover {\n    background-color: #fcf9f3; }\n  .posts .post .title {\n    font-weight: bold; }\n  .posts .post .description {\n    color: #898a8e; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/forums/show-forum/show-forum.component.scss
// module id = 397
// module chunks = 0